(function () {
  'use strict';

  var DEBUG = true;
  function log() {
    if (!DEBUG) return;
    var args = ['[B2B]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  // Resolve the worker API base for the current store.
  // KEEP IDENTICAL to tests/api-base.mjs — change there, run
  // `node --test tests/api-base.test.mjs`, then mirror here.
  function workerApiBase(shopDomain) {
    if (shopDomain === 'hairdressing-supplies-dev.myshopify.com') {
      return 'https://b2b-pricing-api-shop2.digital-709.workers.dev';
    }
    return '';
  }
  // Live store + previews => '' (relative path, unchanged). The shop2 sandbox store
  // => the isolated shop2 worker cross-origin. Uses Shopify.shop so a dev-store
  // preview also routes correctly.
  function apiBase() {
    return workerApiBase((window.Shopify && window.Shopify.shop) || location.hostname);
  }

  var CACHE_TTL = 15 * 60 * 1000; // 15 minutes
  var REFRESH_AT = 7.5 * 60 * 1000; // 50% TTL — trigger background refresh

  // Build a lowercase lookup map so SKU matching is case-insensitive
  function buildSkuLookup(skuPrices) {
    var map = {};
    for (var sku in skuPrices) {
      if (skuPrices.hasOwnProperty(sku)) {
        map[sku.toLowerCase()] = skuPrices[sku];
      }
    }
    return map;
  }

  function lookupSku(skuLookup, sku) {
    return skuLookup[sku.toLowerCase()];
  }

  function formatGBP(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  // Forwards ONLY the sold-out-substitute keys to the Worker — never the whole
  // properties bag. Line properties can hold anything a customer typed (gift
  // messages, personalisation), and none of that is the pricing API's business.
  function substituteProps(item) {
    var p = item.properties;
    if (!p || typeof p !== 'object') return {};
    var out = {};
    if (p._substitute_for) out._substitute_for = String(p._substitute_for);
    if (p._substitute_for_sku) out._substitute_for_sku = String(p._substitute_for_sku);
    return out;
  }

  function getTierFromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)b2b_tier=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Source-based pricing: a guest arriving from a tagged marketing link carries a
  // src_campaign (or src_segment) cookie (set by source-segment-cookie.liquid). Such a
  // guest has no b2b_tier, so we must still run the price-DISPLAY path (below) — the worker
  // resolves the segment from the same-origin cookie and returns the special price. Returns
  // true when a segment cookie is present.
  function hasSourceSegment() {
    return /(?:^|;\s*)src_(?:campaign|segment)=[^;]+/.test(document.cookie);
  }

  function getCacheKey(tier) {
    // Per-customer overrides make prices customer-specific, so key the cache by customer too
    // (a tier-only key would serve one shopper's overridden prices to another on the same tier).
    var cid = (window.__b2b_customer_id != null) ? String(window.__b2b_customer_id) : 'guest';
    return 'b2b_prices_' + tier + '_' + cid;
  }

  function readCache(tier) {
    try {
      var raw = sessionStorage.getItem(getCacheKey(tier));
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (!cached || !cached.timestamp) return null;
      var age = Date.now() - cached.timestamp;
      if (age > CACHE_TTL) return null;
      cached._age = age;
      return cached;
    } catch (e) {
      return null;
    }
  }

  function writeCache(tier, data) {
    try {
      sessionStorage.setItem(getCacheKey(tier), JSON.stringify({
        tier: data.tier,
        skuPrices: data.skuPrices,
        handlePrices: data.handlePrices,
        timestamp: Date.now()
      }));
    } catch (e) {
      // sessionStorage full or unavailable — continue without cache
    }
  }

  function fetchPrices(tier) {
    log('Fetching prices from API...');
    // Pass BOTH the tier and the logged-in customer id. The b2b_tier cookie can't cross to
    // the worker's origin cross-domain (e.g. the dev store on *.myshopify.com → *.workers.dev),
    // so the tier must go in ?tags=; the customer id lets the worker overlay any per-customer
    // price overrides (Override module) on top of the tier prices for product/listing display.
    var cid = (window.__b2b_customer_id != null) ? String(window.__b2b_customer_id) : '';
    var myTierUrl = apiBase() + '/api/prices/my-tier?tags=' + encodeURIComponent(tier || '')
      + (cid ? ('&customer_id=' + encodeURIComponent(cid)) : '');
    return fetch(myTierUrl, { credentials: 'include' })
      .then(function (res) {
        log('API response status:', res.status);
        if (!res.ok) throw new Error('API ' + res.status);
        return res.json();
      })
      .then(function (data) {
        log('API returned', Object.keys(data.skuPrices || {}).length, 'SKU prices');
        return data;
      });
  }

  // ─── Price Application ──────────────────────────────────────────

  function applyPDPPrices(skuPrices) {
    var scriptEl = document.querySelector('script[id^="VariantData-"]');
    if (!scriptEl) { log('PDP: No VariantData script found'); return; }

    var variants;
    try {
      variants = JSON.parse(scriptEl.textContent);
    } catch (e) {
      log('PDP: Failed to parse VariantData');
      return;
    }

    if (!Array.isArray(variants) || variants.length === 0) { log('PDP: No variants found'); return; }

    var skuLookup = buildSkuLookup(skuPrices);
    var modified = false;
    var matchCount = 0;
    variants.forEach(function (v) {
      if (!v.sku) return;
      var b2b = lookupSku(skuLookup, v.sku);
      // Only apply the B2B price when it actually beats the retail (general) price.
      // Tier order is general (retail) >= plus >= partner >= wholesale, so retail is the
      // ceiling: a tier price set ABOVE retail (e.g. a mis-set plus price) must never show —
      // the customer can always buy at the general price. Leave the variant at retail.
      if (b2b === undefined || b2b >= v.price) return;
      v.compare_at_price = v.price;
      v.price = b2b;
      modified = true;
      matchCount++;
    });

    log('PDP: Matched', matchCount, 'of', variants.length, 'variants');

    if (!modified) return;

    // Write modified variant data back so theme's own variant-change JS reads B2B prices
    scriptEl.textContent = JSON.stringify(variants, null, 2);

    // Update the currently displayed price (first variant)
    var first = variants[0];
    if (!first.sku || lookupSku(skuLookup, first.sku) === undefined) return;

    // Use the post-loop variant price, NOT a fresh lookup: the loop leaves a variant at
    // retail when its B2B price is not below retail, so first.price is the B2B price only
    // when it beat retail — never a B2B price above the general/retail price.
    var b2bPrice = first.price;
    var originalCents = first.compare_at_price;
    log('PDP: Setting initial price', formatGBP(b2bPrice), '(was', formatGBP(originalCents) + ')');

    // Update main price display
    var priceEl = document.querySelector('span[id^="ProductPrice-"]');
    if (priceEl) priceEl.textContent = formatGBP(b2bPrice);

    // Only show sale styling if there's an actual discount
    if (originalCents > b2bPrice) {
      var compareEl = document.querySelector('s.psinglePrice');
      if (compareEl) {
        compareEl.textContent = formatGBP(originalCents);
        compareEl.className = compareEl.className.replace(/\bhide\b/, '').trim();
      }

      var currentPriceSpan = document.querySelector('span.psinglePrice:not(s)');
      if (currentPriceSpan) currentPriceSpan.className = 'psinglePrice sale';

      var badge = document.querySelector('.discount-badge');
      if (badge) {
        badge.className = 'discount-badge';
        var saveAmount = badge.querySelector('.product-single__save-amount');
        if (saveAmount) saveAmount.textContent = formatGBP(originalCents - b2bPrice);
        var pctEl = badge.querySelector('.off span');
        if (pctEl) pctEl.textContent = String(Math.round(((originalCents - b2bPrice) / originalCents) * 100));
      }
    } else {
      // No discount — hide sale elements
      var compareEl2 = document.querySelector('s.psinglePrice');
      if (compareEl2) compareEl2.classList.add('hide');

      var currentPriceSpan2 = document.querySelector('span.psinglePrice:not(s)');
      if (currentPriceSpan2) currentPriceSpan2.className = 'psinglePrice';

      var badge2 = document.querySelector('.discount-badge');
      if (badge2) badge2.classList.add('hide');
    }
  }

  function applyPLPPrices(handlePrices) {
    var cards = document.querySelectorAll('.priceWraper[data-product-handle]');
    log('PLP: Found', cards.length, 'price cards');
    cards.forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      if (!handle || !handlePrices[handle]) return;
      var min = handlePrices[handle].min;
      // Idempotency guard: skip the innerHTML rewrite when this card already
      // shows the same B2B price. The marker is set via setAttribute, which the
      // recommendations observer (childList/subtree only — no attributes:true)
      // does NOT see, so it can never re-trigger the observer. This kills the
      // self-feedback loop independently of the disconnect guard below.
      if (el.getAttribute('data-b2b-applied') === String(min)) return;
      el.innerHTML = '<span class="pr_price">' + formatGBP(min) + '</span>';
      el.setAttribute('data-b2b-applied', String(min));
    });
  }

  function applyCartPrices(skuPrices) {
    var items = document.querySelectorAll('[data-cart-sku]');
    if (!items.length) return;
    log('Cart: Found', items.length, 'cart items');

    var skuLookup = buildSkuLookup(skuPrices);
    var subtotal = 0;
    var hasB2B = false;

    items.forEach(function (el) {
      var sku = el.getAttribute('data-cart-sku');
      var qty = parseInt(el.getAttribute('data-cart-qty') || '1', 10);
      var originalLinePrice = parseInt(el.getAttribute('data-cart-line-price') || '0', 10);

      var b2bPrice = sku ? lookupSku(skuLookup, sku) : undefined;
      var retailUnit = qty > 0 ? (originalLinePrice / qty) : originalLinePrice;
      // Cap at retail: only show a B2B line price when it is below the general/retail price.
      if (b2bPrice !== undefined && b2bPrice < retailUnit) {
        hasB2B = true;
        var lineTotal = b2bPrice * qty;
        subtotal += lineTotal;
        el.innerHTML = '<div class="fl f-aie cart-item__discounted-prices">' +
          '<s class="cart-item__old-price price price--end mr5">' + formatGBP(originalLinePrice) + '</s><br>' +
          '<span class="price price--end b2b-price">' + formatGBP(lineTotal) + '</span>' +
          '</div>';
      } else {
        subtotal += originalLinePrice;
      }
    });

    if (hasB2B) {
      var stEl = document.querySelector('[data-cart-subtotal]');
      if (stEl) stEl.textContent = formatGBP(subtotal) + ' GBP';
    }
  }

  function applyShadePrices(skuPrices) {
    var skuLookup = buildSkuLookup(skuPrices);
    var els = document.querySelectorAll('.shade-variant-price[data-variant-sku]');
    els.forEach(function (el) {
      var sku = el.getAttribute('data-variant-sku');
      var bp = sku ? lookupSku(skuLookup, sku) : undefined;
      if (bp !== undefined) el.textContent = formatGBP(bp);
    });
  }

  function applyAllPrices(data) {
    log('Applying all prices...');
    _tierApplied = true; // the displayed price is now the real one — the quest badge may render
    applyPDPPrices(data.skuPrices);
    applyPLPPrices(data.handlePrices);
    applyCartPrices(data.skuPrices);
    applyShadePrices(data.skuPrices);
    renderQtyBreakTable(); // reflect the applied (tier/override) price in the break table
    renderQuestBadge();    // ...and against the quest badge's "does it actually beat this?" test
  }

  // ─── PDP Quantity-Break Table ───────────────────────────────────
  // Advertises a product's quantity-break ladder ("Buy 10+ £8.20 each") on the PDP. Data comes
  // from GET /api/prices/quantity-breaks (its own endpoint so it works for guests, who never hit
  // the tier flow). "Smart enough to only show when needed": a rung is rendered only when its
  // price BEATS the shopper's current unit price, and the whole table is hidden when none do — so
  // a deep-tier B2B customer already below every rung sees nothing. The break counts across the
  // product's shades; the actual charge is computed at cart/checkout with best-of vs the B2B tier.
  //
  // GATE: the table is currently shown to `debug`-tagged accounts ONLY (see hasDebugTag). Everyone
  // else — guests, retail, real B2B customers — never fetches the ladder and never sees the table.
  // Remove the two hasDebugTag() checks below to advertise it to all shoppers.

  // PARKED 2026-08-06 at the user's request while the quest badge is trialled — two competing
  // "you could pay less" widgets under one price is noise. The code is intact: set this to true
  // to bring the table back, and the `debug` gate below still applies on top of it.
  var QTY_BREAK_ADVERT = false;

  var _qtyBreakRungs = null; // [{ minQty, price(£), message }] for THIS product, or null

  // `window.__b2b_customer_tags` is a JSON array of the logged-in customer's downcased tags,
  // injected inline by b2b-tier-cookie.liquid (theme.liquid head, before this deferred script).
  // It is UNDEFINED for guests. Exact array match — not a substring test on the cookie string —
  // so tags like `nodebug` can't false-positive.
  function hasDebugTag() {
    var tags = window.__b2b_customer_tags;
    return !!(tags && tags.indexOf('debug') !== -1);
  }

  function gbp(pounds) { return '£' + Number(pounds).toFixed(2); }

  // The shopper's current per-unit price in POUNDS — the selected variant's live price from
  // VariantData (cents; applyPDPPrices rewrites it to the B2B price when it beats retail), else
  // the displayed ProductPrice text. Null when neither is available.
  function currentPdpUnitPricePounds() {
    var scriptEl = document.querySelector('script[id^="VariantData-"]');
    if (scriptEl) {
      try {
        var variants = JSON.parse(scriptEl.textContent);
        if (Array.isArray(variants) && variants.length) {
          var skuEl = document.querySelector('.product-sku span');
          var cur = skuEl && skuEl.textContent.trim().toLowerCase();
          var v = (cur && variants.find(function (x) { return x.sku && x.sku.toLowerCase() === cur; })) || variants[0];
          if (v && typeof v.price === 'number') return v.price / 100;
        }
      } catch (e) { /* fall through to the text price */ }
    }
    var priceEl = document.querySelector('span[id^="ProductPrice-"]');
    if (priceEl) {
      var n = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
      if (isFinite(n)) return n;
    }
    return null;
  }

  function injectQtyBreakStyles() {
    if (document.getElementById('b2b-qb-style')) return;
    var css =
      '.b2b-qty-breaks{margin:14px 0;max-width:320px}' +
      '.b2b-qty-breaks .b2b-qb-cap{font-size:12px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;opacity:.7;margin-bottom:6px;text-align:left}' +
      '.b2b-qty-break-table{width:100%;border-collapse:collapse;font-size:14px}' +
      '.b2b-qty-break-table th,.b2b-qty-break-table td{padding:7px 14px;border:1px solid #e6d3df;text-align:left}' +
      '.b2b-qty-break-table th{background:#f4d9e6;font-weight:700}' +
      '.b2b-qty-break-table td.b2b-qb-price,.b2b-qty-break-table th.b2b-qb-price{text-align:right;font-variant-numeric:tabular-nums}' +
      '.b2b-qty-break-table tbody tr:nth-child(even){background:#fbeef4}' +
      '.b2b-qty-break-table tbody tr:first-child{font-weight:600}' +
      '.b2b-qty-breaks .b2b-qb-foot{font-size:11px;opacity:.6;margin-top:5px}';
    var s = document.createElement('style');
    s.id = 'b2b-qb-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function renderQtyBreakTable() {
    if (!QTY_BREAK_ADVERT) return; // parked — see the flag
    if (!hasDebugTag()) return; // debug-tagged accounts only — gate the DOM insert itself
    if (!_qtyBreakRungs || !_qtyBreakRungs.length) return;
    var priceEl = document.querySelector('span[id^="ProductPrice-"]');
    var anchor = priceEl && priceEl.closest('.psinglePriceWr');
    if (!anchor) return;

    var curP = currentPdpUnitPricePounds();
    if (curP == null) return;

    // Only rungs that actually beat the shopper's current unit price (tiny epsilon for float noise).
    var rungs = _qtyBreakRungs.filter(function (r) { return Number(r.price) < curP - 0.001; });

    var existing = document.getElementById('b2b-qty-breaks');
    if (!rungs.length) { if (existing) existing.parentNode.removeChild(existing); return; } // hide when none beat

    injectQtyBreakStyles();
    var body = '<tr><td>1</td><td class="b2b-qb-price">' + gbp(curP) + '</td></tr>';
    rungs.forEach(function (r) {
      body += '<tr><td>' + r.minQty + '+</td><td class="b2b-qb-price">' + gbp(r.price) + '</td></tr>';
    });
    var html =
      '<div class="b2b-qb-cap">Buy more, save more</div>' +
      '<table class="b2b-qty-break-table"><thead><tr>' +
        '<th>Buy</th><th class="b2b-qb-price">Price</th>' +
      '</tr></thead><tbody>' + body + '</tbody></table>' +
      '<div class="b2b-qb-foot">Price per unit &middot; mix any shades of this product</div>';

    if (existing) {
      existing.innerHTML = html;
    } else {
      var wrap = document.createElement('div');
      wrap.id = 'b2b-qty-breaks';
      wrap.className = 'b2b-qty-breaks';
      wrap.innerHTML = html;
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    }
  }

  // Fetch this product's ladder (guest-safe endpoint) and render. Runs independently of the tier
  // flow, so a `debug` account still gets the advert when it has no B2B tier. No-op for non-debug
  // accounts and guests, off a PDP, or when the product has no ladder.
  function initQuantityBreaks(tier) {
    if (!QTY_BREAK_ADVERT) return; // parked — see the flag; no fetch either
    if (!hasDebugTag()) return; // debug-tagged accounts only — don't even fetch the ladder
    var idEl = document.querySelector('#product [data-product-id], [data-product-id]');
    var pid = idEl && idEl.getAttribute('data-product-id');
    if (!pid) return; // not a product page
    var url = apiBase() + '/api/prices/quantity-breaks?product_id=' + encodeURIComponent(pid)
      + '&tags=' + encodeURIComponent(tier || '');
    fetch(url, { credentials: 'include' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.quantityBreaks) return;
        var rungs = data.quantityBreaks[pid];
        if (!rungs || !rungs.length) return;
        _qtyBreakRungs = rungs;
        renderQtyBreakTable();
      })
      .catch(function () { /* advert only — ignore failures */ });
  }

  // ─── PDP Quest Badge ────────────────────────────────────────────
  // A customer holding a quest ("expiring agreed price") can reach a better price than the one
  // on screen, and nothing on the storefront used to say so. This badges the PDP price with what
  // the price COULD be and what it takes to get there.
  //
  // GATE: `debug`-tagged accounts ONLY, exactly like the quantity-break table above — gated both
  // in initQuestBadge() (non-debug shoppers never emit the request) and at the top of
  // renderQuestBadge() (covers every call site). Remove both hasDebugTag() calls to ungate, but
  // NOT before the checkout gate in the worker's resolveQuestPricingForItems() goes — otherwise a
  // customer is shown an unlock price that checkout will not honour.
  //
  // Two states, and the price rule that separates them: /api/prices/my-tier already overlays
  // ACTIVE quests, so on an active quest the displayed price ALREADY IS the reward price and
  // there is no better price to advertise. Lapsed quests are the ones with something to offer.

  var _quests = null; // raw /api/prices/my-quests payload for this customer, or null

  // The badge's whole judgement — "does this reward actually beat what you'd pay?" — is measured
  // against the price ON SCREEN, so it must not run until the tier/override price has replaced
  // the retail one. /api/prices/my-quests is a single small D1 read and routinely wins the race
  // against /api/prices/my-tier, which would otherwise compute a percent_off reward off RETAIL
  // (5% off £11.00, not off the £8.50 wholesale price) and flash a wrong figure until
  // applyAllPrices re-rendered it. Set once the displayed price is final — including the paths
  // where "final" means retail: a debug account with no tier, or a failed tier fetch.
  var _tierApplied = false;

  var EPS = 0.001; // float-noise epsilon, same as the quantity-break rung filter

  // ── Pure model — KEEP IDENTICAL to tests/quest-badge.test.mjs ──────────────
  // (theme JS cannot import modules — change there, run `node --test tests/quest-badge.test.mjs`,
  // then mirror here.)

  // Titleise a handle or search term for customer-facing copy:
  // 'hair-care-offers' -> 'Hair Care Offers', 'shampoo' -> 'Shampoo'.
  function titleiseHandle(s) {
    return String(s || '')
      .split(/[-_\s]+/)
      .filter(function (w) { return w.length; })
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
      .join(' ');
  }

  // What the spend/quantity must be ON, as customer copy — or null when we can't say,
  // in which case the sentence falls back to "qualifying products".
  //
  // criteria_scope/criteria_values arrive from /api/prices/my-quests. They are ABSENT until
  // the worker carrying them is promoted to production, so every caller must tolerate null.
  // 'sku'/'product' deliberately return null rather than printing a raw id or sku at the
  // customer; 'all' returns null too, and the sentence simply omits the "on X" clause.
  function questScopeLabel(q) {
    var scope = q && q.criteria_scope;
    var values = (q && q.criteria_values) || [];
    if (!scope || scope === 'all') return null;
    if (scope === 'sku' || scope === 'product') return null;
    if (!values.length) return null;
    return values.map(titleiseHandle).filter(Boolean).join(' and ') || null;
  }

  function gbpAmount(n) { return '£' + Number(n).toFixed(2); }

  // Target as words. 'quantity' targets are UNIT counts and must never be formatted as money.
  function questTargetPhrase(q) {
    var amt = Number(q.target_amount) || 0;
    if (q.target_type === 'quantity') {
      var units = Math.round(amt);
      return { verb: 'Buy', amount: units + ' unit' + (units === 1 ? '' : 's'), joiner: ' of ' };
    }
    return { verb: 'Spend', amount: gbpAmount(amt), joiner: ' on ' };
  }

  // Progress so far this cycle, in the target's own unit.
  function questProgressPhrase(q) {
    var spent = Number(q.spend_this_cycle) || 0;
    var target = Number(q.target_amount) || 0;
    if (q.target_type === 'quantity') {
      return Math.round(spent) + ' of ' + Math.round(target) + ' units this cycle';
    }
    return gbpAmount(spent) + ' of ' + gbpAmount(target) + ' this cycle';
  }

  // Does this reward line cover the product on screen?
  //   sku        — the SELECTED variant's sku
  //   product    — the PDP product id
  //   collection — the product id is in the ids resolved at quest-save time
  // brand/product_type are intentionally unsupported: the theme exposes neither vendor nor
  // product type on the PDP, and the Laravel admin hides both scopes anyway.
  function rewardMatchesProduct(r, ctx) {
    if (!r || !r.match_type) return false;
    var mv = String(r.match_value == null ? '' : r.match_value).toLowerCase();
    if (r.match_type === 'sku') {
      return !!ctx.sku && mv === String(ctx.sku).toLowerCase();
    }
    if (r.match_type === 'product') {
      return !!ctx.productId && mv === String(ctx.productId).toLowerCase();
    }
    if (r.match_type === 'collection') {
      if (!ctx.productId) return false;
      var ids = r.resolved_values || [];
      for (var i = 0; i < ids.length; i++) {
        if (String(ids[i]) === String(ctx.productId)) return true;
      }
      return false;
    }
    return false;
  }

  // The £ this reward would charge. percent_off mirrors tier.ts EXACTLY — including that it
  // rounds in PENCE (`Math.round(cur * (1 - value/100))` on a pence integer). Rounding in
  // pounds instead is off by a penny on any half-penny result: 5% off £8.50 is charged at
  // £8.08, and a badge advertising £8.07 would be a price the checkout never honours.
  // Null when it can't be computed.
  function rewardPricePounds(r, currentPrice) {
    var v = Number(r.value);
    if (!isFinite(v)) return null;
    if (r.price_type === 'fixed') return v >= 0 ? v : null;
    if (r.price_type === 'percent_off') {
      if (currentPrice == null || v < 0 || v > 100) return null;
      return Math.round(Math.round(currentPrice * 100) * (1 - v / 100)) / 100;
    }
    return null;
  }

  /**
   * Decide what — if anything — to show beside the PDP price.
   *
   * ctx: { productId, sku, currentPrice (POUNDS, what the shopper sees now), productTitle }
   *
   *   - lapsed  + reward beats the displayed price -> the unlock badge
   *   - active                                     -> a quieter confirmation, no price claim
   * Anything else shows nothing.
   */
  function questBadgeModel(quests, ctx) {
    var hidden = { show: false };
    if (!quests || !quests.length || !ctx) return hidden;
    var cur = (ctx.currentPrice == null || !isFinite(Number(ctx.currentPrice)))
      ? null : Number(ctx.currentPrice);
    if (cur == null) return hidden;

    var rungs = [];     // every lapsed reward on this product that beats the shown price
    var activeQ = null; // first active quest that rewards this product

    for (var i = 0; i < quests.length; i++) {
      var q = quests[i];
      var rewards = (q && q.rewards) || [];
      for (var j = 0; j < rewards.length; j++) {
        var r = rewards[j];
        if (!rewardMatchesProduct(r, ctx)) continue;
        var p = rewardPricePounds(r, cur);
        if (q.status === 'active') {
          // The reward is already merged into the displayed price. Claim it ONLY when the
          // displayed price actually equals the reward — otherwise something else (a deeper
          // tier, an override, a promo) is what the shopper is seeing, and calling it "your
          // agreed price" would be false. percent_off can't be checked this way (the percent
          // is already off, so recomputing from the displayed price double-applies it), so
          // it is accepted on trust — the active copy makes no price claim.
          var trustworthy = (r.price_type === 'percent_off')
            || (p != null && Math.abs(p - cur) < 0.005);
          if (trustworthy && !activeQ) activeQ = q;
          continue;
        }
        if (p == null) continue;
        if (p < cur - EPS) rungs.push({ price: p, quest: q, target: Number(q.target_amount) || 0 });
      }
    }

    if (rungs.length) {
      // A LADDER is the dominant live shape: "Wella £100 -> 5% off", "£200 -> 10%", "£300 -> 15%"
      // are three separate quests rewarding the same products. Headline the rung the shopper can
      // most easily REACH (lowest target), not the deepest price — "spend £300" as the only offer
      // both undersells the £100 rung and overfaces the shopper. Deeper rungs are listed under it.
      rungs.sort(function (a, b) { return (a.target - b.target) || (a.price - b.price); });
      var primary = rungs[0];
      var q1 = primary.quest;
      var t = questTargetPhrase(q1);
      var scope1 = questScopeLabel(q1);
      var what = scope1 ? (t.joiner + scope1) : (q1.criteria_scope === 'all' ? '' : ' on qualifying products');

      // Same split the cart bar and account panel make, and for the same reason: status
      // 'lapsed' covers two different customers. starts_active === 0 means this quest was
      // NEVER granted — it is an unlock offer. === 1 means it was granted and has since been
      // lost, so "unlock" would deny they ever held it. Absent (today's payload shape) MUST
      // fall back to the loss wording — offering an "unlock" to someone who genuinely lost the
      // price is the worse of the two errors, per assets/b2b-pricing.js cartQuestBarModel.
      var startsActive = q1.starts_active;
      var earnFirst = startsActive !== undefined && startsActive !== null && Number(startsActive) === 0;

      // Everything DEEPER than the headline is listed under it, each labelled with its own
      // target and scope. Labelling every entry (rather than grouping by criteria and printing
      // bare targets) means one rule covers both shapes: rungs of one ladder AND a deeper reward
      // from an entirely different deal. Nothing a customer could reach is ever hidden, and no
      // entry is ambiguous about what the spend must be on.
      var more = [];
      var seen = {};
      var deeper = rungs.slice(1).filter(function (x) { return x.price < primary.price - EPS; });
      // By target, not by price: the list reads as a ladder the shopper climbs.
      deeper.sort(function (a, b) { return (a.target - b.target) || (a.price - b.price); });
      for (var k = 0; k < deeper.length; k++) {
        var tk = questTargetPhrase(deeper[k].quest);
        var sk = questScopeLabel(deeper[k].quest);
        var label = tk.amount + (sk ? (tk.joiner + sk) : '') + ' → ' + gbpAmount(deeper[k].price);
        if (seen[label]) continue;
        seen[label] = 1;
        more.push(label);
      }

      return {
        show: true,
        state: 'unlock',
        price: primary.price,
        // Shown ON the pill, blurred, as the teaser the shopper clicks to reveal.
        amount: gbpAmount(primary.price),
        pill: 'Better price',
        // One line, the way the shopper thinks about it.
        line: 'Get ' + (ctx.productTitle ? ctx.productTitle : 'it') + ' for ' + gbpAmount(primary.price),
        // NOTE: no "so far this cycle" here on purpose. Once a quest has lapsed, accumulated
        // spend never brings it back — only ONE order reaching the target does. Showing a
        // running total would imply progress the engine does not honour.
        detail: t.verb + ' ' + t.amount + what + ' in a single order to '
          + (earnFirst ? 'unlock this price' : 'get this price back')
          + ' — then it\'s locked in for 28 days.',
        ladder: more.length ? ('Also available: ' + more.join(' · ')) : null,
        progress: null,
        questName: q1.name || '',
      };
    }

    if (activeQ) {
      var t2 = questTargetPhrase(activeQ);
      var scope2 = questScopeLabel(activeQ);
      var what2 = scope2 ? (t2.joiner + scope2) : (activeQ.criteria_scope === 'all' ? '' : ' on qualifying products');
      var days = Number(activeQ.days_left);
      return {
        show: true,
        state: 'active',
        price: null,
        amount: null, // nothing to tease — they already have this price
        pill: 'Agreed price',
        line: 'Your agreed price is active',
        detail: 'Keep it by ' + t2.verb.toLowerCase() + 'ing ' + t2.amount + what2
          + ' every 28 days.',
        ladder: null,
        progress: questProgressPhrase(activeQ)
          + (isFinite(days) ? (' · ' + days + ' day' + (days === 1 ? '' : 's') + ' left') : ''),
        questName: activeQ.name || '',
      };
    }

    return hidden;
  }

  // ── end of the block mirrored into tests/quest-badge.test.mjs ──────────────

  // "Price coming down": a ring broken on the left, an arrow dropping through the break, and a
  // £ inside. Traced off the reference art (200x200) and scaled to a 24 viewBox at x0.12 —
  //   ring stroke 7 -> 0.84 | circle cx 119 r 74 -> cx 14.3 r 8.9
  //   arrow shaft x 38 -> 4.6, y 55..140 -> 5.9..16.6 | head arms out to x 17..62 -> 1.9..7.3
  // Stroke is 1.05 rather than the reference's 0.84: at the 17px this renders at, a 0.84 hairline
  // greys out to mush. Everything stroked (no solid fills) to match the reference's own style,
  // and the £ is drawn rather than <text> so it can't shift with the theme's font. Inherits
  // `currentColor`. Two earlier attempts failed here — a percent sign that read as decoration,
  // and a solid arrow at double the reference's stroke weight — so change it against the art,
  // rendered side by side, not by eye in the editor.
  var QUEST_ICON =
    '<svg class="b2b-quest-ico" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" ' +
      'focusable="false" fill="none" stroke="currentColor" stroke-width="1.05" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M7.2 6.5A8.9 8.9 0 1 1 7.2 17.5"/>' +
      '<path d="M4.6 5.9V16.6"/><path d="M1.9 13.7 4.6 16.7 7.3 13.7"/>' +
      '<path d="M16.4 9.2c-.4-1.2-1.7-1.8-2.9-1.3-1.1.5-1.6 1.7-1.4 2.9l.5 3c.2 1.2-.3 2-1.1 2.4"/>' +
      '<path d="M11.1 16.2h5.9"/><path d="M11.6 12.4h3.9"/>' +
    '</svg>';

  var QUEST_TICK =
    '<svg class="b2b-quest-ico" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" ' +
      'focusable="false" fill="none" stroke="currentColor" stroke-width="1.9" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="m4 12.5 5.5 5.5L20 6"/></svg>';

  function injectQuestBadgeStyles() {
    if (document.getElementById('b2b-quest-style')) return;
    var css =
      // Sit the badge ON the price line, not under it. The price wrapper is switched to
      // inline-flex so a following inline sibling shares its line — done this way because the
      // badge CANNOT live inside .psinglePriceWr: product-template.liquid's variant-swap does
      // `oldPriceWrapper.innerHTML = newPriceWrapper.innerHTML` and would delete it. Scoped to
      // the marker class so PDPs without a badge keep the theme's own layout untouched.
      '.b2b-quest-row>.psinglePriceWr{display:inline-flex;vertical-align:middle}' +
      '.b2b-quest{position:relative;display:inline-flex;vertical-align:middle;' +
        'margin:0 0 0 10px;font-size:13px;line-height:1.45}' +
      // No pill chrome — the icon and the blurred price ARE the badge. A bordered capsule next to
      // a large price read as a second button competing with Add to Cart.
      '.b2b-quest-pill{display:inline-flex;align-items:center;gap:6px;padding:0;margin:0;' +
        'border:0;background:none;color:#b0004e;font:inherit;font-size:15px;font-weight:700;' +
        'line-height:1;letter-spacing:.01em;cursor:pointer;' +
        'transition:color .08s linear,opacity .08s linear}' +
      '.b2b-quest-pill:hover,.b2b-quest-pill[aria-expanded="true"]{color:#7d0038}' +
      '.b2b-quest-pill:focus-visible{outline:2px solid #b0004e;outline-offset:3px;' +
        'border-radius:4px}' +
      '.b2b-quest-ico{flex:0 0 auto}' +
      // The teaser: a real price, blurred past legibility until the shopper clicks to reveal.
      '.b2b-quest-amt{font-variant-numeric:tabular-nums;filter:blur(4.5px);opacity:.85;' +
        'user-select:none;transition:filter .22s ease,opacity .22s ease}' +
      '.b2b-quest--revealed .b2b-quest-amt{filter:none;opacity:1}' +
      '@media (prefers-reduced-motion:reduce){.b2b-quest-amt,.b2b-quest-pill{transition:none}}' +
      '.b2b-quest--active .b2b-quest-pill{color:#2e7d32;font-size:13px}' +
      '.b2b-quest--active .b2b-quest-pill:hover,' +
      '.b2b-quest--active .b2b-quest-pill[aria-expanded="true"]{color:#1f5b23}' +
      '.b2b-quest--active .b2b-quest-pill:focus-visible{outline-color:#2e7d32}' +
      '.b2b-quest-pop{position:absolute;z-index:30;top:calc(100% + 8px);left:0;width:290px;' +
        'max-width:78vw;padding:12px 14px;background:#fff;color:#333;text-align:left;' +
        'border:1px solid #e6d3df;border-radius:10px;' +
        'box-shadow:0 6px 22px rgba(0,0,0,.13)}' +
      '.b2b-quest-pop[hidden]{display:none}' +
      '.b2b-quest-pop::before{content:"";position:absolute;top:-6px;left:22px;width:10px;' +
        'height:10px;background:#fff;border-left:1px solid #e6d3df;border-top:1px solid #e6d3df;' +
        'transform:rotate(45deg)}' +
      '.b2b-quest-line{font-weight:700;font-size:14px;color:#111}' +
      '.b2b-quest-more{display:inline-flex;align-items:center;gap:4px;margin-top:6px;padding:0;' +
        'border:0;background:none;color:#b0004e;font:inherit;font-size:12px;font-weight:600;' +
        'text-decoration:underline;cursor:pointer}' +
      '.b2b-quest--active .b2b-quest-more{color:#2e7d32}' +
      '.b2b-quest-more:focus-visible{outline:2px solid currentColor;outline-offset:2px}' +
      '.b2b-quest-det{margin-top:8px;padding-top:8px;border-top:1px solid #f0e4ec;' +
        'font-size:12.5px;color:#555}' +
      '.b2b-quest-det[hidden]{display:none}' +
      '.b2b-quest-ladder{margin-top:6px;font-weight:600;color:#b0004e;font-size:12px}' +
      '.b2b-quest-prog{margin-top:5px;font-weight:600;color:#333}' +
      '.b2b-quest-name{margin-top:5px;font-size:11px;opacity:.6}' +
      '@media (max-width:600px){.b2b-quest-pop{left:auto;right:0}' +
        '.b2b-quest-pop::before{left:auto;right:22px}}';
    var s = document.createElement('style');
    s.id = 'b2b-quest-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function questEscape(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // The selected variant's sku — the same lookup the quantity-break table uses.
  function currentPdpSku() {
    var skuEl = document.querySelector('.product-sku span');
    var shown = skuEl && skuEl.textContent.trim();
    if (shown) return shown;
    var scriptEl = document.querySelector('script[id^="VariantData-"]');
    if (!scriptEl) return '';
    try {
      var variants = JSON.parse(scriptEl.textContent);
      if (Array.isArray(variants) && variants.length && variants[0].sku) return variants[0].sku;
    } catch (e) { /* no sku available */ }
    return '';
  }

  // Long trade titles blow the one-liner out; keep the badge readable.
  function questShortTitle() {
    var el = document.querySelector('.product-single__title');
    var t = el ? el.textContent.trim().replace(/\s+/g, ' ') : '';
    if (!t) return '';
    return t.length > 44 ? (t.slice(0, 43).replace(/[\s,–-]+$/, '') + '…') : t;
  }

  function questProductId() {
    var idEl = document.querySelector('#product [data-product-id], [data-product-id]');
    return (idEl && idEl.getAttribute('data-product-id')) || '';
  }

  var _questHideTimer = null;

  function questSetOpen(root, open) {
    var pill = root.querySelector('.b2b-quest-pill');
    var pop = root.querySelector('.b2b-quest-pop');
    if (!pill || !pop) return;
    pill.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { pop.removeAttribute('hidden'); } else { pop.setAttribute('hidden', ''); }
  }

  // Has the shopper clicked through the blurred teaser? Always true for the active state, which
  // has no hidden price, so hover works there immediately.
  function questIsRevealed(root) {
    return root.className.indexOf('b2b-quest--revealed') !== -1;
  }

  function questIsOpen(root) {
    var pill = root.querySelector('.b2b-quest-pill');
    return !!pill && pill.getAttribute('aria-expanded') === 'true';
  }

  // Hover opens on pointer devices; click/tap toggles and PINS (so moving the pointer away
  // doesn't close something the shopper deliberately opened); Escape and outside-click close.
  // Hover alone would be dead on touch and invisible to a keyboard.
  //
  // EVERY listener is bound to `root` (or `document`) and delegates — never to the pill or the
  // Details link directly. A shade change rewrites root.innerHTML, which destroys any listener
  // attached to an inner node but leaves root's own listeners alive: re-binding after a rewrite
  // would therefore stack a SECOND copy of the survivors, and two delegated click handlers
  // toggling the same aria-expanded cancel each other out — Details would silently stop working
  // on a re-rendered badge. Delegation means bind-once is correct and re-binding is unnecessary.
  function questBindInteractions(root) {
    if (root.getAttribute('data-b2b-quest-bound') === '1') return;
    root.setAttribute('data-b2b-quest-bound', '1');

    // Hover opens ONLY once the price has been revealed. Before that, hovering must not open the
    // panel: the panel states the price in words, which would defeat the blurred teaser entirely.
    root.addEventListener('mouseenter', function () {
      if (!questIsRevealed(root)) return;
      clearTimeout(_questHideTimer);
      questSetOpen(root, true);
    });
    root.addEventListener('mouseleave', function () {
      if (root.getAttribute('data-pinned') === '1') return;
      clearTimeout(_questHideTimer);
      _questHideTimer = setTimeout(function () { questSetOpen(root, false); }, 90);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && questIsOpen(root)) {
        questSetOpen(root, false);
        root.setAttribute('data-pinned', '0');
        var p = root.querySelector('.b2b-quest-pill');
        if (p) p.focus();
      }
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // The pill itself. The FIRST click is the reveal — unblur the price and open the panel
      // together, so one deliberate action does the whole thing. After that it just toggles.
      if (t.closest('.b2b-quest-pill')) {
        e.preventDefault();
        if (!questIsRevealed(root)) {
          root.className += ' b2b-quest--revealed';
          questSetOpen(root, true);
          root.setAttribute('data-pinned', '1');
          return;
        }
        var wasOpen = questIsOpen(root);
        questSetOpen(root, !wasOpen);
        root.setAttribute('data-pinned', wasOpen ? '0' : '1');
        return;
      }

      // Details disclosure inside the popover.
      var more = t.closest('.b2b-quest-more');
      if (!more) return;
      e.preventDefault();
      var det = root.querySelector('.b2b-quest-det');
      if (!det) return;
      var open = more.getAttribute('aria-expanded') === 'true';
      more.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) { det.setAttribute('hidden', ''); } else { det.removeAttribute('hidden'); }
      root.setAttribute('data-pinned', '1');
    });

    document.addEventListener('click', function (e) {
      if (!root.parentNode) return;
      if (root.contains(e.target)) return;
      questSetOpen(root, false);
      root.setAttribute('data-pinned', '0');
    });
  }

  function renderQuestBadge() {
    if (!hasDebugTag()) return; // debug-tagged accounts only — gate the DOM insert itself
    if (!_tierApplied) return;  // wait for the real price — applyAllPrices calls back in
    if (!_quests || !_quests.length) return;

    var priceEl = document.querySelector('span[id^="ProductPrice-"]');
    var anchor = priceEl && priceEl.closest('.psinglePriceWr');
    if (!anchor) return;

    var m = questBadgeModel(_quests, {
      productId: questProductId(),
      sku: currentPdpSku(),
      currentPrice: currentPdpUnitPricePounds(),
      productTitle: questShortTitle(),
    });

    var existing = document.getElementById('b2b-quest');
    if (!m.show) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }

    injectQuestBadgeStyles();

    // The unlock pill wears the price itself, blurred — the shopper clicks to reveal it. The
    // blurred text is aria-hidden and the button carries a plain label instead: a screen reader
    // has no notion of "blurred", so reading the number out would hand over what the visual
    // deliberately withholds, and reading it twice (pill + panel) is just noise.
    var pillFace = m.amount
      ? '<span class="b2b-quest-amt" aria-hidden="true">' + questEscape(m.amount) + '</span>'
      : '<span>' + questEscape(m.pill) + '</span>';
    var pillLabel = m.amount ? 'Reveal a better price on this product' : questEscape(m.pill);

    var html =
      '<button type="button" class="b2b-quest-pill" aria-expanded="false" aria-controls="b2b-quest-pop"' +
        ' aria-label="' + pillLabel + '">' +
        (m.state === 'active' ? QUEST_TICK : QUEST_ICON) +
        pillFace +
      '</button>' +
      '<div class="b2b-quest-pop" id="b2b-quest-pop" hidden>' +
        '<div class="b2b-quest-line">' + questEscape(m.line) + '</div>' +
        '<button type="button" class="b2b-quest-more" aria-expanded="false" aria-controls="b2b-quest-det">Details</button>' +
        '<div class="b2b-quest-det" id="b2b-quest-det" hidden>' +
          '<div>' + questEscape(m.detail) + '</div>' +
          (m.ladder ? '<div class="b2b-quest-ladder">' + questEscape(m.ladder) + '</div>' : '') +
          (m.progress ? '<div class="b2b-quest-prog">' + questEscape(m.progress) + '</div>' : '') +
          (m.questName ? '<div class="b2b-quest-name">' + questEscape(m.questName) + '</div>' : '') +
        '</div>' +
      '</div>';

    // The active state has no hidden price, so it starts revealed and hover works at once. A
    // shade change must NOT re-blur a price the shopper already clicked to see, so an existing
    // reveal is carried across the re-render.
    function questClasses(root) {
      var revealed = (!m.amount) || (root && questIsRevealed(root));
      return 'b2b-quest b2b-quest--' + m.state + (revealed ? ' b2b-quest--revealed' : '');
    }

    // Re-render in place on a shade change without stealing an open popover away from the
    // shopper: only rewrite when the visible content actually changed.
    if (existing) {
      existing.className = questClasses(existing);
      if (existing.getAttribute('data-sig') !== m.state + '|' + m.line + '|' + m.detail + '|' + (m.ladder || '')) {
        existing.setAttribute('data-sig', m.state + '|' + m.line + '|' + m.detail + '|' + (m.ladder || ''));
        existing.innerHTML = html;
        // Deliberately NOT re-bound: every listener is delegated from `root`, which this rewrite
        // leaves untouched. Re-binding here would double them up — see questBindInteractions.
      }
      return;
    }

    var wrap = document.createElement('div');
    wrap.id = 'b2b-quest';
    wrap.className = questClasses(null);
    wrap.setAttribute('data-sig', m.state + '|' + m.line + '|' + m.detail + '|' + (m.ladder || ''));
    wrap.innerHTML = html;
    // Sibling AFTER .psinglePriceWr, never inside it — for TWO reasons, both load-bearing:
    // the wrapper is role="status" (a live region would announce the badge on every shade
    // change), and product-template.liquid's variant swap does
    // `oldPriceWrapper.innerHTML = newPriceWrapper.innerHTML`, which would silently delete it.
    // The marker class on the parent is what puts it back on the price's LINE via CSS.
    if (anchor.parentNode.className.indexOf('b2b-quest-row') === -1) {
      anchor.parentNode.className += ' b2b-quest-row';
    }
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    questBindInteractions(wrap);
  }

  // Fetch this customer's quests once per PDP and render. Guests have no customer id and never
  // reach here; non-debug accounts never emit the request at all.
  function initQuestBadge() {
    if (!hasDebugTag()) return; // debug-tagged accounts only — don't even fetch
    if (window.__b2b_customer_id == null) return; // guests hold no quests
    if (!questProductId()) return; // not a product page
    var url = apiBase() + '/api/prices/my-quests?customer_id='
      + encodeURIComponent(String(window.__b2b_customer_id));
    fetch(url, { credentials: 'include' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var quests = (data && data.quests) || [];
        if (!quests.length) return;
        _quests = quests;
        renderQuestBadge();
      })
      .catch(function () { /* badge only — never break the PDP */ });
  }

  // ─── MutationObservers ──────────────────────────────────────────

  // ─── Recommendations Observer ───────────────────────────────────
  // product-recommendations elements load their cards via AJAX after an
  // IntersectionObserver fires — b2b prices must be re-applied once the
  // new .priceWraper[data-product-handle] nodes land in the DOM.

  // ─── Quick-view modal ───────────────────────────────────────────
  // The quick-view is fetched by AJAX and injected into the page long after init, so
  // nothing had ever priced it — a wholesale customer opened it and saw the general
  // price. It is the surface the sold-out alternatives strip opens, so it must be
  // tier-correct. Keyed on handle (the modal renders no SKU: `settings.qvsku` is unset).
  function applyQuickViewPrice(handlePrices) {
    var box = document.getElementById('content_quickview');
    if (!box) return;
    var root = box.querySelector('[data-product-url]');
    if (!root) return;
    var handle = (root.getAttribute('data-product-url') || '').split('?')[0].replace(/\/$/, '').split('/').pop();
    var hp = handle && handlePrices[handle];
    if (!hp) return;

    var wrap = box.querySelector('.psinglePriceWr');
    if (!wrap) return;
    // Same idempotency marker as applyPLPPrices: set via setAttribute so the
    // childList observer below can never see it and re-trigger itself.
    if (wrap.getAttribute('data-b2b-applied') === String(hp.min)) return;

    var priceEl = wrap.querySelector('.psinglePrice:not(s)');
    if (!priceEl) return;
    var wasText = (priceEl.textContent || '').trim();

    // handlePrices carries min AND max. On a product whose variants differ in price a
    // flat min would quote the customer LOWER than several of its variants, so say
    // "From" rather than state a price the modal cannot honour for every variant.
    var label = (hp.max != null && hp.max !== hp.min)
      ? 'From ' + formatGBP(hp.min)
      : formatGBP(hp.min);
    priceEl.textContent = label;
    priceEl.classList.add('sale');

    // Show what they would have paid at general tier, using the price the modal was
    // rendered with. Only when it is genuinely higher — never invent a saving.
    var strike = wrap.querySelector('s.psinglePrice');
    var wasPence = Math.round(parseFloat((wasText.replace(/[^0-9.]/g, '') || '0')) * 100);
    if (strike && wasPence > hp.min) {
      strike.textContent = wasText;
      strike.classList.remove('hide');
    }

    wrap.setAttribute('data-b2b-applied', String(hp.min));
    log('QuickView: priced', handle, label);
  }

  function setupQuickViewObserver(handlePrices) {
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        // Disconnect across our own writes, exactly as the recommendations observer
        // does — otherwise the textContent/class changes re-queue this callback.
        obs.disconnect();
        applyQuickViewPrice(handlePrices);
        obs.takeRecords();
        obs.observe(document.body, { childList: true, subtree: true });
      }, 60);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function setupRecommendationsObserver(handlePrices) {
    var recEls = document.querySelectorAll('product-recommendations');
    if (!recEls.length) return;
    log('Observer: Watching', recEls.length, 'product-recommendations element(s)');
    recEls.forEach(function (el) {
      var recTimer;
      var recOpts = { childList: true, subtree: true };
      var obs = new MutationObserver(function () {
        clearTimeout(recTimer);
        recTimer = setTimeout(function () {
          log('Observer: product-recommendations content updated — re-applying PLP prices');
          // Disconnect across our own innerHTML rewrites so the self-generated
          // childList mutations are never queued — otherwise they re-fire this
          // observer in an infinite loop (~6/sec). disconnect() empties the
          // queue; takeRecords() is belt-and-braces. applyPLPPrices is fully
          // synchronous and the rec lazy-load is one-shot, so the disconnected
          // window is negligible. (A bare boolean guard would NOT work here:
          // observer callbacks are microtasks delivered after the flag resets.)
          obs.disconnect();
          applyPLPPrices(handlePrices);
          obs.takeRecords();
          obs.observe(el, recOpts);
        }, 150);
      });
      obs.observe(el, recOpts);
    });
  }

  function setupObservers(skuPrices) {
    var cartTimer;
    var cartApplying = false;
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      log('Observer: Watching cart-drawer');
      new MutationObserver(function () {
        if (cartApplying) return;
        clearTimeout(cartTimer);
        cartTimer = setTimeout(function () {
          cartApplying = true;
          applyCartPrices(skuPrices);
          cartApplying = false;
        }, 150);
      }).observe(cartDrawer, { childList: true, subtree: true });
    }

    var shadeTimer;
    var shadeApplying = false;
    var shadeModal = document.getElementById('shade-modal');
    if (shadeModal) {
      log('Observer: Watching shade-modal');
      function onShadeChange() {
        if (shadeApplying) return;
        clearTimeout(shadeTimer);
        shadeTimer = setTimeout(function () {
          shadeApplying = true;
          applyShadePrices(skuPrices);
          shadeApplying = false;
        }, 100);
      }
      // Watch content rebuilds (product switch via combined listing)
      new MutationObserver(onShadeChange).observe(shadeModal, { childList: true, subtree: true });
      // Watch modal open (openModal() adds class 'active' — no child mutation)
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'class' && shadeModal.classList.contains('active')) {
            onShadeChange();
          }
        });
      }).observe(shadeModal, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // ─── Variant Change Handling ────────────────────────────────────

  function updatePDPForCurrentVariant(skuPrices) {
    var skuEl = document.querySelector('.product-sku span');
    if (!skuEl) { log('Variant change: No .product-sku span found'); return; }
    var currentSku = skuEl.textContent.trim();
    if (!currentSku) { log('Variant change: SKU element empty'); return; }

    var skuLookup = buildSkuLookup(skuPrices);
    var hasB2bPrice = lookupSku(skuLookup, currentSku) !== undefined;

    var scriptEl = document.querySelector('script[id^="VariantData-"]');
    if (!scriptEl) return;
    var variants;
    try { variants = JSON.parse(scriptEl.textContent); } catch (e) { return; }

    var currentSkuLower = currentSku.toLowerCase();
    var variant = variants.find(function (v) { return v.sku && v.sku.toLowerCase() === currentSkuLower; });
    if (!variant) { log('Variant change: SKU not in VariantData', currentSku); return; }

    // No B2B price — show the retail price so we don't leave a stale price on screen
    if (!hasB2bPrice) {
      log('Variant change: No B2B price for SKU', currentSku, '— showing retail');
      var retailPrice = variant.compare_at_price || variant.price;
      var priceEl = document.querySelector('span[id^="ProductPrice-"]');
      if (priceEl) priceEl.textContent = formatGBP(retailPrice);

      var compareEl = document.querySelector('s.psinglePrice');
      if (compareEl) compareEl.classList.add('hide');
      var currentPriceSpan = document.querySelector('span.psinglePrice:not(s)');
      if (currentPriceSpan) currentPriceSpan.className = 'psinglePrice';
      var badge = document.querySelector('.discount-badge');
      if (badge) badge.classList.add('hide');
      renderQtyBreakTable(); // re-filter the break table against the newly shown retail price
      renderQuestBadge();
      return;
    }

    // variant.price is the post-loop value: the B2B price only when it beat retail (the
    // initial loop leaves a variant at retail otherwise), so we never display above retail.
    var b2bPrice = variant.price;
    var originalCents = variant.compare_at_price || variant.price;
    log('Variant change: SKU', currentSku, '→', formatGBP(b2bPrice), '(was', formatGBP(originalCents) + ')');

    var priceEl = document.querySelector('span[id^="ProductPrice-"]');
    if (priceEl && priceEl.textContent !== formatGBP(b2bPrice)) {
      priceEl.textContent = formatGBP(b2bPrice);
    }

    if (originalCents > b2bPrice) {
      var compareEl = document.querySelector('s.psinglePrice');
      if (compareEl) {
        compareEl.textContent = formatGBP(originalCents);
        compareEl.className = compareEl.className.replace(/\bhide\b/, '').trim();
      }

      var currentPriceSpan = document.querySelector('span.psinglePrice:not(s)');
      if (currentPriceSpan) currentPriceSpan.className = 'psinglePrice sale';

      var badge = document.querySelector('.discount-badge');
      if (badge) {
        badge.className = 'discount-badge';
        var saveAmount = badge.querySelector('.product-single__save-amount');
        if (saveAmount) saveAmount.textContent = formatGBP(originalCents - b2bPrice);
        var pctEl = badge.querySelector('.off span');
        if (pctEl) pctEl.textContent = String(Math.round(((originalCents - b2bPrice) / originalCents) * 100));
      }
    } else {
      var compareEl2 = document.querySelector('s.psinglePrice');
      if (compareEl2) compareEl2.classList.add('hide');

      var currentPriceSpan2 = document.querySelector('span.psinglePrice:not(s)');
      if (currentPriceSpan2) currentPriceSpan2.className = 'psinglePrice';

      var badge2 = document.querySelector('.discount-badge');
      if (badge2) badge2.classList.add('hide');
    }
    renderQtyBreakTable(); // re-filter the break table against the newly selected variant's price
    renderQuestBadge();    // a shade change moves the base price, so re-test the quest reward
  }

  function setupVariantChangeHandler(skuPrices) {
    // Listen for dropdown/swatch changes and re-apply B2B price
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.swatchInput, .single-option-selector, select')) return;
      log('Variant change event from:', e.target.tagName, e.target.className || e.target.id);
      setTimeout(function () { updatePDPForCurrentVariant(skuPrices); }, 100);
    });

    // Catch product:updated event dispatched by Combined Listing script
    document.addEventListener('product:updated', function () {
      log('product:updated event fired');
      setTimeout(function () { updatePDPForCurrentVariant(skuPrices); }, 100);
    });
  }

  // ─── Cart Discount Sync (for checkout) ─────────────────────────
  //
  // Race condition fix: if a sync is already in flight when a new cart
  // mutation arrives, we set _pendingSync rather than silently dropping
  // the request. When the in-flight sync completes (success or error),
  // it checks _pendingSync and re-queues a new sync so no update is lost.
  // This is critical for customers on slow connections where a single sync
  // can easily take longer than the 1 s debounce window.

  var _syncTimer = null;
  var _syncing = false;
  var _pendingSync = false;
  var _pendingTags = null;
  var _partialRetries = 0; // partial-response guard (see _doSyncCartDiscounts write step)

  function syncCartDiscounts(tags) {
    // Debounce: wait 250ms after last call before executing.
    // (Was 1000ms; reduced so the freshly-applied discount surfaces promptly
    // on first add — see _doSyncCartDiscounts / rerenderCartDrawer.)
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(function () { _doSyncCartDiscounts(tags); }, 250);
  }

  // Swap the freshly-rendered cart-drawer HTML (returned by the Section
  // Rendering API alongside our attribute write) into the live drawer DOM so
  // the server-side B2B function discount becomes visible WITHOUT the user
  // touching quantity.
  //
  // Mirrors the theme's own onCartUpdate() swap (theme.js), but with the
  // CORRECTED footer selector: this theme's snippet uses `.drawer__footer`
  // (cart-drawer.liquid L164), not Dawn's `.cart-drawer__footer`. The subtotal
  // (`.cart_total`) lives in the footer, OUTSIDE `cart-drawer-items`, so the
  // footer must be swapped too or the subtotal won't update.
  //
  // No fetch is issued here (replaceWith only), so this does NOT re-trigger
  // shouldTriggerSync — no sync loop. replaceWith also upgrades the inserted
  // <cart-drawer-items> custom element, same as the theme relies on.
  function rerenderCartDrawer(sectionHTML) {
    if (!sectionHTML) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { log('Cart sync: no cart-drawer in DOM — skipping re-render'); return; }
    var parsed;
    try {
      parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
    } catch (e) {
      log('Cart sync: failed to parse section HTML', e);
      return;
    }
    ['cart-drawer-items', '.drawer__footer'].forEach(function (sel) {
      var target = drawer.querySelector(sel);
      var source = parsed.querySelector(sel);
      if (target && source) target.replaceWith(source);
    });
    log('Cart sync: cart-drawer re-rendered from server');
    // The swap above restored the server-rendered free-delivery bar. The quest bar itself is
    // untouched — it lives on #quest-bar-mount, outside everything swapped here — but the
    // .has-quest-bar class that hides the delivery messages is on #CartDrawer, and this is
    // the cheapest place to re-assert it. Strictly this is belt-and-braces: #CartDrawer is
    // not replaced either. It costs one class write and it never decides anything.
    paintQuestBar();
  }

  // Parse the numeric variant IDs that carry a discount out of a compact
  // payload ("VARIANTID:DISCOUNT:MESSAGE|...") or an existing b2b_discounts
  // cart attribute. Used by the partial-response guard below.
  function parseDiscountVids(compact) {
    if (!compact) return [];
    return compact.split('|').map(function (entry) {
      return entry.split(':')[0];
    }).filter(Boolean);
  }

  // True when the live cart drawer ALREADY displays the B2B price for every line
  // the Worker says is discounted. applyCartPrices() (the cart-drawer observer)
  // injects a `.b2b-price` span per discounted line client-side; if all of them
  // are present, the minicart is correct and a section re-render would only reflow
  // an already-correct drawer. The re-render is reserved for when a B2B price has
  // NOT yet been applied to the display.
  function cartDrawerShowsDiscounts(discountedSkus) {
    if (!discountedSkus.length) return true;        // nothing discounted to show
    var els = document.querySelectorAll('[data-cart-sku]');
    if (!els.length) return false;                  // drawer not rendered yet → not applied
    var bySku = {};
    els.forEach(function (el) {
      var s = (el.getAttribute('data-cart-sku') || '').toLowerCase();
      if (s) bySku[s] = el;
    });
    return discountedSkus.every(function (sku) {
      var el = bySku[sku.toLowerCase()];
      return !!(el && el.querySelector('.b2b-price'));
    });
  }

  // ─── Checkout gate ──────────────────────────────────────────────
  // Grey out + block the mini-cart checkout button while a cart change is being
  // re-priced, so a customer can't reach checkout on stale prices (e.g. a BXGY
  // free unit that no longer applies after a qty change). Released once the sync
  // settles and the drawer shows the confirmed prices. A failsafe timeout always
  // releases so a hung/failed sync can never trap the customer at checkout.
  var _cartVerifying = false;
  var _verifyTimeout = null;
  var CHECKOUT_SELECTORS = '#CartDrawer-Checkout, #checkout, [name="checkout"], .cartDWcheckout';

  function setCartVerifying(on) {
    on = !!on;
    if (_cartVerifying === on) return;
    _cartVerifying = on;
    if (document.body) document.body.classList.toggle('b2b-cart-verifying', on);
    clearTimeout(_verifyTimeout);
    if (on) {
      log('Checkout gated — confirming cart prices');
      // Never trap the customer: force-release if a sync hangs.
      _verifyTimeout = setTimeout(function () {
        log('Checkout gate: failsafe release after 8s');
        _cartVerifying = false;
        if (document.body) document.body.classList.remove('b2b-cart-verifying');
      }, 8000);
    } else {
      log('Checkout released — prices confirmed');
    }
  }

  function setupCheckoutGate() {
    var style = document.createElement('style');
    style.textContent =
      'body.b2b-cart-verifying #CartDrawer-Checkout,' +
      'body.b2b-cart-verifying #checkout,' +
      'body.b2b-cart-verifying [name="checkout"],' +
      'body.b2b-cart-verifying .cartDWcheckout{' +
      'opacity:.5!important;pointer-events:none!important;cursor:not-allowed!important;}' +
      // While re-pricing, dim the cart items + subtotal (a "ghost loader") so the
      // intermediate re-renders (qty set first, then the BXGY line split a moment
      // later) settle under a calm "updating" state and reveal once correct, instead
      // of reading as a jarring shift. The +/- buttons stay interactive (only checkout
      // is blocked), and the opacity transition makes the reveal smooth.
      'body.b2b-cart-verifying cart-drawer-items,' +
      'body.b2b-cart-verifying .drawer__footer{' +
      'opacity:.6;transition:opacity .2s ease;}';
    (document.head || document.documentElement).appendChild(style);

    // Belt-and-braces: block the click/submit even if the CSS is bypassed.
    document.addEventListener('click', function (e) {
      if (!_cartVerifying) return;
      var t = e.target && e.target.closest ? e.target.closest(CHECKOUT_SELECTORS) : null;
      if (t) { e.preventDefault(); e.stopImmediatePropagation(); log('Checkout click blocked — prices not yet confirmed'); }
    }, true);
    document.addEventListener('submit', function (e) {
      if (_cartVerifying && e.target && /cart/i.test(e.target.id || '')) {
        e.preventDefault(); e.stopImmediatePropagation(); log('Checkout submit blocked — prices not yet confirmed');
      }
    }, true);
  }

  // Read the price the mini-cart drawer is CURRENTLY displaying (last £x.xx in the
  // subtotal element), in cents — so we can compare it to the real cart total.
  function readDrawerTotalCents() {
    var el = document.querySelector('.cart_total');
    if (!el) return null;
    var m = (el.textContent || '').match(/[\d,]+\.\d{2}/g);
    if (!m || !m.length) return null;
    return Math.round(parseFloat(m[m.length - 1].replace(/,/g, '')) * 100);
  }

  // Before releasing the checkout gate, confirm the DISPLAYED total matches the real
  // cart total. If the drawer is stale (e.g. showing full price when a BXGY free unit
  // has already applied server-side), reload the drawer section and re-check; keep
  // checkout locked until they agree. ("If things aren't adding up, reload and make it
  // fit.") Failsafe-releases after a few tries so the customer is never trapped — the
  // real cart/checkout total is correct regardless of what the drawer shows.
  function confirmDisplayThenRelease(tags) {
    fetch('/cart.js', { credentials: 'include' }).then(function (r) { return r.json(); }).then(function (cart) {
      var actual = cart.total_price;
      // Compare the drawer's displayed total to the real cart and reload until they
      // agree — re-checking by reading the drawer only (no extra /cart.js round-trips)
      // and with a short settle, so the gate releases quickly and the cart stops
      // re-rendering (each reload briefly drops the +/- buttons).
      function check(n) {
        var shown = readDrawerTotalCents();
        if (shown === null || shown === actual) { setCartVerifying(false); return; }
        if (n >= 3) {
          log('Checkout gate: still mismatched after retries — releasing (real checkout total is correct)');
          setCartVerifying(false);
          return;
        }
        log('Checkout gate: drawer £' + (shown / 100).toFixed(2) + ' vs cart £' + (actual / 100).toFixed(2) + ' — reloading drawer');
        fetch('/cart?section_id=cart-drawer', { credentials: 'include' })
          .then(function (r) { return r.text(); })
          .then(function (html) { rerenderCartDrawer(html); setTimeout(function () { check(n + 1); }, 80); })
          .catch(function () { setCartVerifying(false); });
      }
      check(0);
    }).catch(function () { setCartVerifying(false); });
  }

  function _afterSync(tags) {
    _syncing = false;
    if (_pendingSync) {
      _pendingSync = false;
      var pt = _pendingTags;
      _pendingTags = null;
      log('Cart sync: re-queuing pending sync...');
      syncCartDiscounts(pt || tags);
    } else {
      // Settled — but only release checkout once the DISPLAYED price is confirmed
      // to match the real cart (reload the drawer if it's stale).
      confirmDisplayThenRelease(tags);
      // Signal discount-codes.liquid to recompute promo codes against the now-settled cart,
      // so order-code amounts / best-of never go stale on a cart change. This cart sync fires
      // reliably on every change (it intercepts fetch + XHR), so it's the trustworthy trigger.
      // Our own writes use ?b2b_skip=1 and are not re-captured, so this cannot loop.
      try { document.dispatchEvent(new CustomEvent('b2b:cart-synced')); } catch (e) {}
    }
  }

  // Cart freshness stamp — MUST stay identical to tests/promo-sig.mjs and to the copy
  // inlined in snippets/discount-codes.liquid (that copy is unit-tested with `node --test`).
  //
  // We publish this as the `b2b_price_sig` cart attribute on every path where pricing
  // authoritatively concludes for this cart, so the checkout gate can tell "priced, and
  // it happened to owe nothing" apart from "never priced". Without it the gate only saw
  // `b2b_promo_sig` (written by the OTHER script) and released unpriced carts to
  // checkout at full retail — HDS234073 and 6 others, Aug 2026.
  function sig(cart) {
    var items = (cart && cart.items) || [];
    var pairs = items.map(function (i) { return i.variant_id + ':' + i.quantity; }).sort();
    return String((cart && cart.items_subtotal_price) || 0) + '|' + pairs.join(',');
  }

  // Which pricing identity a stamp belongs to. KEEP IDENTICAL to tests/gate-freshness.mjs.
  function identityKey(customerId) {
    return customerId == null || customerId === '' ? 'guest' : String(customerId);
  }

  // The value written to BOTH `b2b_price_sig` and `b2b_promo_sig`. Identity-bound because
  // sig(cart) covers only subtotal and variant:qty — a cart surviving login/logout/
  // account-switch with unchanged items keeps an identical signature even though the price it
  // should be sold at has changed completely. KEEP IDENTICAL to tests/gate-freshness.mjs.
  function tagsKey(customerTags) {
    if (customerTags == null) return 'guest';
    if (!Array.isArray(customerTags)) return 'unknown';
    var joined = customerTags.map(function (t) { return String(t).toLowerCase(); }).sort().join(',');
    var h = 0x811c9dc5;
    for (var i = 0; i < joined.length; i++) {
      h ^= joined.charCodeAt(i);
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h.toString(36);
  }

  function cartStamp(customerId, customerTags, cart) {
    return identityKey(customerId) + '.' + tagsKey(customerTags) + '|' + sig(cart);
  }

  // Build the `attributes` payload for one /cart/update.js write, or null when there is
  // genuinely nothing to write (stamp already current AND no payload) — returning an object
  // in that steady state would issue a cart write on every single sync.
  // KEEP IDENTICAL to stampAttributes() in tests/price-stamp.mjs — change there, run
  // `node --test "tests/**/*.test.mjs"`, then mirror here.
  // Returns a NEW object; never mutates the caller's.
  function stampAttributes(storedPriceSig, cartSig, extraAttrs) {
    var attrs = Object.assign({}, extraAttrs || {});
    var needsStamp = storedPriceSig !== cartSig;
    if (!needsStamp && !Object.keys(attrs).length) return null;  // healthy steady state
    if (needsStamp) attrs.b2b_price_sig = cartSig;
    return attrs;
  }

  // Is an empty Worker response authoritative — i.e. did the request carry usable tags?
  // KEEP IDENTICAL to isAuthoritativeEmpty() in tests/empty-response.mjs — change there, run
  // `node --test "tests/**/*.test.mjs"`, then mirror here.
  //
  // Deliberately separate from shouldClearStaleDiscount() below: that one ALSO returns false
  // merely because there is no stale attribute to clear, which says nothing about authority.
  // Inferring authority from it made every cart with nothing discountable look unpriced.
  function isAuthoritativeEmpty(customerTags) {
    // Guest: the global is never assigned, so there is no tag source. Public promos need no
    // tags, so an empty result is the truth.
    if (customerTags == null) return true;
    // Logged in: b2b-tier-cookie.liquid assigns `window.__b2b_customer_tags` SYNCHRONOUSLY,
    // inline in <head> (line 24, inside `{% if customer %}`), before either consumer runs —
    // discount-codes.liquid renders after it, and b2b-pricing.js is deferred. So an array IS
    // the answer, including an empty one for a customer who genuinely holds no tags. Treating
    // [] as "tags not ready" described a state that cannot occur, and forced those carts
    // through the 5s fail-open with a false b2b_unpriced marker.
    return Array.isArray(customerTags);
  }

  // Decide whether to CLEAR a lingering `b2b_discounts` cart attribute when the
  // Worker authoritatively returned no discount for the current cart.
  // KEEP IDENTICAL to tests/should-clear-stale-discount.mjs — change there, run
  // `node --test tests/should-clear-stale-discount.test.mjs`, then mirror here.
  function shouldClearStaleDiscount(currentAttr, customerTags) {
    if (!currentAttr) return false;                    // nothing stale to clear
    return isAuthoritativeEmpty(customerTags);         // otherwise: only if the empty is real
  }

  /* ─── Cart quest bar model — KEEP IDENTICAL to tests/cart-quest-bar.mjs ─── */

  // Where the customer can go to actually qualify.
  //
  // A 'collection' criteria_value IS a real handle — resolveCollectionProductIds resolves it
  // to product ids at quest-save time, so /collections/<handle> is safe. 'brand' and
  // 'product_type' are NOT handles: they are vendor/type strings, and /collections/<vendor>
  // would 404 more often than not. Those go to search, which always exists.
  //
  // 'sku' and 'product' return null on purpose: the payload has a lowercased sku or a numeric
  // id, neither of which is a URL, and guessing a handle from them lands the customer on a 404.
  // A missing link is better than a broken one.
  function scopeUrl(q) {
    var scope = q && q.criteria_scope;
    var values = (q && q.criteria_values) || [];
    if (scope === 'all') return '/collections/all';
    if (!scope || !values.length) return null;
    // One button cannot go to two places; the hint text names them all, this takes the first.
    var first = String(values[0]);
    if (scope === 'collection') return '/collections/' + encodeURIComponent(first);
    if (scope === 'brand' || scope === 'product_type' || scope === 'title_contains') {
      return '/search?q=' + encodeURIComponent(first);
    }
    return null;
  }

  // `accrued` is ledger spend already banked THIS cycle, so a customer who spent £10 last week
  // sees the bar start a third full rather than mysteriously at zero.
  //
  // THAT IS TRUE ONLY OF AN ACTIVE QUEST. cartQuestProgress used to filter to active, so this
  // model never saw anything else; the owner reversed that scoping because an unlock offer is
  // the strongest thing to show someone mid-basket. For a NOT-active quest the accrual is real
  // in the ledger and completely irrelevant: drip spend never revives one, only a single
  // qualifying order does. Counting it would show a bar two-thirds full to a customer who in
  // fact needs the whole target in this basket — so the not-active path measures THIS CART
  // against the target and derives its own remaining rather than trusting q.remaining, which
  // the worker nets off against the accrual.
  //
  // An ABSENT status is the production payload today and must behave exactly as before, so
  // nothing moves until the worker ships the new shape.
  function cartQuestBarModel(quests) {
    var list = quests || [];
    if (!list.length) return null;
    // One bar, one goal: the nearest is the winnable one. Including unlock offers is not the
    // same as promoting them, so the picker stays on the payload's own remaining.
    var q = list.slice().sort(function (a, b) { return Number(a.remaining) - Number(b.remaining); })[0];

    var isUnits = q.target_type === 'quantity';
    var isActive = !q.status || q.status === 'active';
    var target = Number(q.target) || 0;
    var cart = Number(q.cart_qualifying) || 0;
    var done = isActive ? ((Number(q.accrued) || 0) + cart) : cart;
    var hasRemaining = q.remaining !== undefined && q.remaining !== null && isFinite(Number(q.remaining));
    var remaining = isActive
      ? (hasRemaining ? Number(q.remaining) : 0)
      : Math.max(0, target - cart);

    // Same three states the account panel splits on, and for the same reason: absent
    // starts_active must never produce the unlock wording, because telling someone who lost a
    // price that they can "unlock" it denies they ever earned it.
    var startsActive = q.starts_active;
    var earnFirst = !isActive
      && startsActive !== undefined && startsActive !== null && Number(startsActive) === 0;

    var scope = questScopeLabel(q);
    var on = scope || 'qualifying products';
    var reward = q.reward_message ? String(q.reward_message) : 'agreed price';

    var need = isUnits
      ? (Math.round(remaining) + ' more unit' + (Math.round(remaining) === 1 ? '' : 's') + ' of ' + on)
      : (gbpAmount(remaining) + ' more on ' + on);

    // Target already met for the cycle. The worker OMITS these today (remaining <= 0), so the
    // bar vanishes at exactly the moment the customer did what was asked — indistinguishable
    // from having no quest at all. This arm is what renders it the day the worker stops
    // omitting; the theme cannot make the entry arrive on its own.
    //
    // Both guards exist because a MISSING field must never assert that a price is held.
    // An absent `remaining` coerces to 0, and an absent `target` makes the derived not-active
    // remaining 0 as well, so an unguarded `remaining <= 0` congratulates a customer on a price
    // the engine never granted — off nothing but a field the worker forgot to send. The
    // unguarded shape degrades to "£0.00 more on qualifying products", which is nonsense but
    // claims nothing; this one would be a lie about money.
    var secured = target > 0 && remaining <= 0 && (!isActive || hasRemaining);
    var headline;
    if (secured) {
      // A not-active quest is NOT granted until the order is placed, so "secured" would be a
      // promise the engine has not made yet.
      headline = isActive
        ? ('Your ' + reward + ' is secured for this cycle.')
        : ('This basket unlocks your ' + reward + '.');
    } else if (isActive) {
      headline = need + ' keeps your ' + reward;
    } else if (earnFirst) {
      headline = need + ' unlocks ' + reward;
    } else {
      headline = need + ' gets your ' + reward + ' back';
    }

    // "this cycle" is only true of the accrual-backed active meter. A not-active bar measures
    // one basket, and saying "this cycle" over a cart-only number invites the customer to read
    // banked spend into it.
    var windowLabel = isActive ? ' this cycle' : ' in this order';

    return {
      name: q.name,
      state: secured ? 'secured' : (isActive ? 'active' : (earnFirst ? 'earn-first' : 'lapsed')),
      headline: headline,
      meter: isUnits
        ? (Math.round(done) + ' of ' + Math.round(target) + ' units' + windowLabel)
        : (gbpAmount(done) + ' of ' + gbpAmount(target) + windowLabel),
      pct: secured ? 100 : (target > 0 ? Math.max(0, Math.min(100, Math.round((done / target) * 100))) : 0),
      url: scopeUrl(q),
    };
  }

  /* ─── end cart quest bar model ─── */

  // The numbers currently on the bar. null = no quest to show, so the mount stands down and
  // the Liquid free-delivery bar is left alone.
  //
  // There is no freeze here and no cached raw payload: the bar is mounted on an element that
  // survives every re-render a quantity change causes (#quest-bar-mount, cart-drawer.liquid),
  // so a change is an in-place text update rather than a rebuild. The whole
  // decide-on-open / hold-while-open / discard-on-close machinery that used to sit here
  // existed only to make a REBUILT bar look stable, and it is gone with the rebuild.
  var _questBarSnapshot = null;

  // Builds the bar ONCE. paintQuestBar() calls this on the first paint only, and thereafter
  // writes over the text nodes this created — see there for why.
  //
  // Built with DOM APIs and textContent rather than an HTML string. The quest name and the
  // reward message are admin-authored free text landing on a customer page, and THIS FILE HAS
  // NO ESCAPING HELPER — esc() lives in account-hub.js, not here. textContent cannot inject
  // markup, so there is nothing left to escape and nothing to get wrong. It also matches how
  // the rest of this file writes text (formatGBP into .textContent).
  function questBarEl(m) {
    var root = document.createElement(m.url ? 'a' : 'div');
    root.className = 'quest-bar';
    if (m.url) root.setAttribute('href', m.url);

    var headline = document.createElement('p');
    headline.className = 'quest-bar__headline';
    headline.textContent = m.headline;

    var track = document.createElement('div');
    track.className = 'quest-bar__track';
    var fill = document.createElement('div');
    fill.className = 'quest-bar__fill';
    fill.style.width = m.pct + '%';
    track.appendChild(fill);

    var meter = document.createElement('p');
    meter.className = 'quest-bar__meter';
    meter.textContent = m.meter;

    root.appendChild(headline);
    root.appendChild(track);
    root.appendChild(meter);
    return root;
  }

  // Fresh data from a cart-discounts response. Recompute and paint, always — the numbers are
  // live now. This is the ONLY place live cart quest data arrives: one call site, inside the
  // _doSyncCartDiscounts .then, plus the failure path in its .catch which stands the bar down
  // by handing over nothing.
  function applyQuestBar(quests) {
    _questBarSnapshot = cartQuestBarModel(quests);
    paintQuestBar();
  }

  // Paint the held snapshot into the stable mount.
  //
  // #quest-bar-mount is an empty div rendered as a direct child of #CartDrawer, OUTSIDE
  // .drawer__inner. That matters and is the whole design: the theme rewrites .drawer__inner's
  // innerHTML on every add and quantity change (CartDrawerItems.getSectionsToRender asks for
  // {id:'CartDrawer', selector:'.drawer__inner'}, theme.js L1939) and rerenderCartDrawer()
  // swaps <cart-drawer-items>, so the previous home of this bar was destroyed and rebuilt
  // several times a minute. Rebuilding is what the owner rejected — the bar has to move and
  // its text has to change without ever leaving the page. So the mount is created once by
  // Liquid, the bar inside it is created once here, and every later call writes only
  // textContent, style.width and href. Nothing is removed and re-inserted.
  //
  // ONE re-render path is not covered by that and must not be mistaken for one that is:
  // cart-notification.liquid's applyDrawerHTML() does `dest.innerHTML = fresh.innerHTML` with
  // dest = #CartDrawer, on every add to cart and on the 422 refresh(). That DOES destroy the
  // mount, and this function is what puts a bar back into the rebuilt one. What stops it
  // being visible is CSS, not code: applyDrawerHTML leaves #CartDrawer's ATTRIBUTES alone, so
  // the .has-quest-bar class below survives the rewrite, and the reserved-height rule in
  // cart-drawer.liquid keyed on that class holds the box open — at full height, displayed —
  // across the whole round-trip. Take that rule away and the bar collapses and comes back on
  // every add. theme.js's own CartDrawer.renderContents()/refresh() are the same shape and
  // are covered the same way; they are dormant only because layout/theme.liquid always
  // renders <cart-notification>, which wins ProductForm's `cart-notification || cart-drawer`.
  //
  // Two consequences worth spelling out, because both used to need code and no longer do:
  //
  //  - No observers. The old build installed two MutationObservers on <cart-drawer> to notice
  //    the theme's re-render and put the bar back. The quantity-change re-render no longer
  //    touches the mount, and the add-to-cart one is handled by the sync that follows it, so
  //    there is nothing left to watch for.
  //
  //  - The delivery messages are NOT touched from here. .progress-bar-container and
  //    .freeShipMsg.ctfreeship are both rebuilt VISIBLE by every one of those re-renders, so
  //    hiding them from JS afterwards showed 129px of delivery bar for a frame and then took
  //    it away — the layout jump this replaced. Instead the class below goes on #CartDrawer,
  //    which the theme never rewrites (it rewrites that element's CHILD), and the CSS in
  //    cart-drawer.liquid — beside the mount, not beside them — hides them from their very
  //    first paint.
  function paintQuestBar() {
    var mount = document.getElementById('quest-bar-mount');
    if (!mount) return;   // /cart, and any template without the drawer — nothing to paint into
    var drawer = document.getElementById('CartDrawer');

    // Precedence: banner > quest > free delivery. One bar, one goal — a promotional banner
    // and a quest bar both asking for a different next action is the thing this feature
    // exists to prevent.
    //
    // The old build got this for free by anchoring on .progress-bar-container: Liquid renders
    // the banner INSTEAD of the delivery bar (cart-drawer.liquid L124/L139 vs L151), so when
    // the banner was up there was no host to paint next to and the bar stood down. Anchoring
    // on the mount instead removed that accident, so the rule is stated explicitly here.
    //
    // Read carefully: this is NOT the thing the .progress-bar-container/.freeShipMsg rule
    // forbids, and the two are different in kind. Those two must never be HIDDEN from here,
    // because the theme rebuilds them visible on every re-render and taking them down in JS
    // afterwards paints them for a frame first. This only ASKS WHETHER A BANNER EXISTS and
    // then declines to reveal the mount — a precedence decision, not a hide. It cannot flash,
    // because the mount only ever goes hidden -> visible on the branch where no banner is
    // present, and it is never written at all on the branch where one is.
    var banner = document.querySelector('#CartDrawer .minicart-banner');

    // Note the snapshot is deliberately NOT cleared when the banner wins. The model is still
    // correct and still live; we are only declining to display it. The moment the banner's
    // date window closes and the drawer re-renders without it, the next paint reveals the
    // bar again with current numbers and no recompute needed.
    if (!_questBarSnapshot || banner) {
      mount.hidden = true;
      if (drawer) drawer.classList.remove('has-quest-bar');
      return;
    }

    var m = _questBarSnapshot;
    // The root is an <a> when the quest has somewhere to send the shopper and a <div> when it
    // does not, so the one thing an in-place update cannot do is change it. Rebuild ONLY on
    // that mismatch, which in practice means the first paint: scopeUrl() is a pure function of
    // criteria_scope, so for a given quest a url is either always there or never there.
    var tag = m.url ? 'A' : 'DIV';
    var bar = mount.firstElementChild;
    if (!bar || bar.tagName !== tag) {
      mount.textContent = '';
      bar = questBarEl(m);
      mount.appendChild(bar);
    } else {
      var headline = bar.querySelector('.quest-bar__headline');
      var meter = bar.querySelector('.quest-bar__meter');
      var fill = bar.querySelector('.quest-bar__fill');
      if (headline) headline.textContent = m.headline;
      if (meter) meter.textContent = m.meter;
      if (fill) fill.style.width = m.pct + '%';
      if (m.url) bar.setAttribute('href', m.url);
    }

    if (drawer) drawer.classList.add('has-quest-bar');
    mount.hidden = false;
  }

  function _doSyncCartDiscounts(tags) {
    if (_syncing) {
      // A sync is already in flight — record that another is needed and bail.
      // _afterSync() will pick this up and re-queue once the current sync finishes.
      log('Cart sync: already in flight, marking pending...');
      _pendingSync = true;
      _pendingTags = tags;
      return;
    }
    _syncing = true;
    log('Cart sync: fetching cart...');

    // Captured from /cart.js for the partial-response guard at the write step.
    var currentAttr = '';
    var cartVids = {};
    var vidToSku = {}; // numeric variant id → sku, for the "drawer already correct?" check
    // Freshness stamp for THIS snapshot, plus whatever stamp the cart already carries.
    var cartSig = '';
    var storedPriceSig = '';

    // Did the quest payload for THIS sync land? The .catch below closes over the whole chain,
    // not just the cart-discounts fetch — a later rejection (the attribute write, /cart/update.js,
    // a res.json()) reaches it long after applyQuestBar() has already banked a good payload.
    // Without this the catch would throw away a cache that is known-valid and already on screen.
    var questsApplied = false;

    // Write the pricing freshness stamp for the snapshot we just priced, merging in any
    // other attributes the caller needs in the same request. Skipped when the stored
    // stamp is already correct and there is nothing else to write, so a healthy cart
    // doesn't issue a pointless write on every sync.
    // ?b2b_skip=1 so the interceptor ignores our own write (same guard as everywhere else).
    function writeStamped(extraAttrs, extra) {
      var attrs = stampAttributes(storedPriceSig, cartSig, extraAttrs);
      if (!attrs) return null;
      var body = { attributes: attrs };
      if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) body[k] = extra[k]; } }
      return fetch('/cart/update.js?b2b_skip=1', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
    }

    // Refresh the stamp alone, for paths that write no payload. Returns a promise that
    // settles once the write has LANDED — callers must await it before _afterSync(), because
    // _afterSync() dispatches b2b:cart-synced, and a settle triggered by that event reads the
    // cart. If the write is still in flight the settle sees no stamp, holds the gate, and
    // nothing calls settleGate() again once the write lands — so an otherwise correctly
    // priced cart sat until the 5s fail-open and collected a false b2b_unpriced marker.
    function stampOnly() {
      var p = writeStamped({});
      if (!p || !p.then) return Promise.resolve();
      return p.catch(function () {});
    }

    fetch('/cart.js', { credentials: 'include' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartSig = cartStamp(window.__b2b_customer_id, window.__b2b_customer_tags, cart);
        storedPriceSig = (cart.attributes && cart.attributes.b2b_price_sig) || '';

        if (!cart.items || !cart.items.length) {
          // An empty cart is trivially "priced" — stamp it so a refill starts from a
          // clean, non-stale state rather than a stamp for the pre-empty contents.
          // _afterSync is deferred until the write lands; see stampOnly().
          return stampOnly().then(function () { _afterSync(tags); });
        }

        // Snapshot the existing attribute + the variant IDs currently in the
        // cart so the write step can detect a degraded Worker response.
        currentAttr = (cart.attributes && cart.attributes.b2b_discounts) || '';
        cart.items.forEach(function (it) {
          cartVids[String(it.variant_id)] = true;
          vidToSku[String(it.variant_id)] = it.sku || '';
        });

        // Build items array for the Worker
        var items = cart.items.map(function (item) {
          return {
            variant_id: 'gid://shopify/ProductVariant/' + item.variant_id,
            sku: item.sku || '',
            quantity: item.quantity,
            price: (item.price / 100).toFixed(2),
            title: item.title || item.product_title || '',
            product_id: String(item.product_id),
            product_tags: [], // tags not available in cart.js — Worker uses title matching
            // Sold-out shade substitutes (bulk shade modal) carry the shade they
            // stand in for. The Worker holds that shade's tier price on this line;
            // every other line sends an empty object and is priced as normal.
            properties: substituteProps(item)
          };
        });

        log('Cart sync: sending', items.length, 'items to Worker...');

        var customerId = window.__b2b_customer_id
          ? 'gid://shopify/Customer/' + window.__b2b_customer_id
          : null;

        // Prefer the customer's REAL tags (injected by b2b-tier-cookie.liquid) so the
        // Worker sees `debug` even for non-b2b accounts. The b2b_tier cookie only
        // carries tags for b2b customers, so fall back to it when no real tags exist.
        var syncTags = (window.__b2b_customer_tags && window.__b2b_customer_tags.length)
          ? window.__b2b_customer_tags
          : (tags ? tags.split(',').filter(Boolean) : []);

        return fetch(apiBase() + '/api/prices/cart-discounts', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tags: syncTags, items: items, customer_id: customerId })
        });
      })
      .then(function (res) {
        if (!res) {
          // Empty cart path — _afterSync already called above
          return null;
        }
        if (!res.ok) throw new Error('Cart discount API ' + res.status);
        return res.json();
      })
      .then(function (result) {
        applyQuestBar(result && result.quests);
        questsApplied = true;
        if (!result || !result.compact) {
          // No discounts now. If the attribute carried a value AND this empty is
          // authoritative (the request carried the customer's real tags, or it's a
          // guest), CLEAR it (and re-render the drawer) — otherwise the checkout
          // Function keeps applying the stale discount, e.g. a BXGY free unit lingering
          // after qty drops below the threshold (bug HDS229620). A spurious empty
          // (logged-in customer whose tags aren't ready) must NOT wipe a valid discount
          // — that caused the £x ↔ £y flicker. Skip the write if it was already empty.
          if (shouldClearStaleDiscount(currentAttr, window.__b2b_customer_tags)) {
            log('Cart sync: clearing stale discount attribute + drawer re-render');
            // Authoritative empty: pricing DID run and owes nothing. Stamp it, or the
            // gate could never tell this apart from "pricing never ran".
            return writeStamped({ b2b_discounts: '' }, {
              sections: 'cart-drawer',
              sections_url: window.location.pathname
            });
          }
          // Nothing to CLEAR — but that is not the same as "not authoritative", and the two
          // must not be conflated. shouldClearStaleDiscount() also returns false simply
          // because currentAttr is empty, which is the normal state of any cart with nothing
          // discountable. Skipping the stamp here made those ordinary carts look unpriced:
          // the gate held for the full 5s fail-open and then wrote b2b_unpriced=1 on them.
          // Authority depends ONLY on whether the request carried usable tags.
          if (isAuthoritativeEmpty(window.__b2b_customer_tags)) {
            log('Cart sync: no discounts for this cart — stamping as priced');
            return stampOnly().then(function () { _afterSync(tags); });
          } else {
            // Under-informed (logged-in customer whose tags aren't ready). Certify nothing;
            // the gate holding is the safe direction and a later sync resolves it.
            log('Cart sync: empty response but tags not ready — not stamping');
          }
          _afterSync(tags);
          return;
        }

        // ── Partial-response guard ──────────────────────────────────────
        // Belt-and-braces against a transient incomplete Worker response
        // (root cause: the worker-side D1 price-sync race) overwriting a
        // good attribute and wiping discounts. Because the theme REPLACES
        // the whole b2b_discounts attribute, one short response can drop
        // every other line until the next cart mutation.
        //
        // We only block the rare regression signature: lines that are STILL
        // in the cart AND were previously discounted would lose their
        // discount in the new payload. This can NOT be triggered by a
        // genuine item removal (removed items aren't in cartVids) or by
        // items that were never discounted. On a suspected partial we keep
        // the previous (good) attribute and retry a couple of times; we
        // never get stuck — after the cap we release and wait for the next
        // cart change. This is a backstop, not a substitute for the
        // worker-side atomic-sync fix.
        var newVids = parseDiscountVids(result.compact);
        var curVids = parseDiscountVids(currentAttr);
        var droppedStillInCart = curVids.filter(function (id) {
          return cartVids[id] && newVids.indexOf(id) === -1;
        });
        if (droppedStillInCart.length >= 2) {
          if (_partialRetries < 2) {
            _partialRetries++;
            log('Cart sync: SUSPECTED PARTIAL response — ' + droppedStillInCart.length +
                ' still-in-cart lines would lose their discount; keeping previous attribute, retry ' +
                _partialRetries + '/2 in 2s');
            _afterSync(tags);
            setTimeout(function () { syncCartDiscounts(tags); }, 2000);
            return;
          }
          log('Cart sync: still partial after retries — keeping previous attribute until next cart change');
          _partialRetries = 0;
          _afterSync(tags);
          return;
        }
        _partialRetries = 0; // healthy response — reset
        // ────────────────────────────────────────────────────────────────

        // Does the live drawer ALREADY show the B2B price for every discounted
        // line? If so, a section re-render would only reflow a correct minicart.
        var discountedSkus = parseDiscountVids(result.compact)
          .map(function (vid) { return vidToSku[vid]; })
          .filter(Boolean);
        var drawerCorrect = cartDrawerShowsDiscounts(discountedSkus);

        if (drawerCorrect && result.compact === currentAttr) {
          // Attribute already current AND minicart already shows B2B prices — nothing to
          // re-render. Still stamp if the freshness marker is behind: the payload can be
          // byte-identical across a cart change that alters `sig` (e.g. a qty change on an
          // undiscounted line), and an unstamped cart would hold the gate until fail-open.
          log('Cart sync: attribute unchanged and minicart already correct — no reflow');
          // _afterSync is deferred until the write lands; see stampOnly().
          return stampOnly().then(function () { _afterSync(tags); });
        }

        log('Cart sync: writing cart attribute (' + result.compact.length + ' bytes)' +
            (drawerCorrect ? ' — minicart already correct, no section re-render' : ' + cart-drawer section re-render'));

        // Always write b2b_discounts (the checkout Function reads it). Only request
        // the `sections: 'cart-drawer'` Section-Rendering re-render — which swaps the
        // drawer DOM and reflows it — when the drawer is NOT already showing the B2B
        // prices. When applyCartPrices() has already injected them, we skip the
        // re-render so a correct minicart never reflows.
        // ?b2b_skip=1 tells the interceptor to ignore this self-write so we don't loop.
        var extra = null;
        if (!drawerCorrect) {
          extra = { sections: 'cart-drawer', sections_url: window.location.pathname };
        }
        // writeStamped() adds b2b_price_sig alongside; b2b_discounts always goes out here
        // regardless of the stamp state, so this write is never skipped.
        return writeStamped({ b2b_discounts: result.compact }, extra);
      })
      .then(function (res) {
        if (!res) {
          // No-compact early-return path already called _afterSync above.
          return;
        }
        return res.json().then(function (cart) {
          log('Cart sync: done');
          // Re-render the drawer from the section HTML returned by the SAME
          // write call (rendered against the post-write cart).
          if (cart && cart.sections && cart.sections['cart-drawer']) {
            rerenderCartDrawer(cart.sections['cart-drawer']);
          } else {
            log('Cart sync: no cart-drawer section in update response');
          }
          _afterSync(tags);
        });
      })
      .catch(function (err) {
        console.error('[B2B] Cart sync failed:', err);
        // applyQuestBar() lives inside the .then above, so a non-ok response lands here with
        // the previous bar still painted and nothing behind it. Stand it down rather than
        // keep asserting a number no response supports; the next sync repaints it.
        //
        // Gated on questsApplied, which is the meaningful distinction: this catch covers the
        // whole chain, so it also fires when the quest payload arrived FINE and something
        // downstream broke. Taking the bar down then would blank a bar the response fully
        // supports.
        if (!questsApplied) applyQuestBar(null);
        _afterSync(tags);
      });
  }

  // Returns true for any cart-mutating URL we want to react to,
  // excluding our own b2b_skip writes.
  function shouldTriggerSync(url) {
    if (url.indexOf('b2b_skip=1') >= 0) return false;
    return url.indexOf('/cart/add') >= 0 ||
           url.indexOf('/cart/change') >= 0 ||
           url.indexOf('/cart/update') >= 0;
  }

  function setupCartSyncInterceptor(tags) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      var willSync = shouldTriggerSync(urlStr);

      // Grey the checkout button the instant a cart change fires, before the
      // request even resolves — released when the re-pricing sync settles.
      if (willSync) setCartVerifying(true);

      var result = origFetch.apply(this, arguments);

      if (willSync) {
        result.then(function () {
          syncCartDiscounts(tags);
        }).catch(function () { setCartVerifying(false); });
      }

      return result;
    };

    // Also intercept XMLHttpRequest for older cart forms
    var origXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._b2bUrl = url;
      return origXHROpen.apply(this, arguments);
    };
    var origXHRSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      var url = self._b2bUrl || '';
      if (shouldTriggerSync(url)) setCartVerifying(true); // grey checkout immediately
      self.addEventListener('load', function () {
        if (shouldTriggerSync(url)) {
          syncCartDiscounts(tags);
        }
      });
      self.addEventListener('error', function () {
        if (shouldTriggerSync(url)) setCartVerifying(false);
      });
      return origXHRSend.apply(this, arguments);
    };
  }

  // ─── Init ───────────────────────────────────────────────────────

  function init() {
    log('Init starting...');
    var tier = getTierFromCookie();

    // Install the checkout gate (greys/blocks checkout while the cart is re-priced).
    setupCheckoutGate();

    // When the page is restored from the browser's back-forward cache (e.g. backing
    // out of checkout), the page JS does NOT re-run, so the restored cart drawer can
    // show a stale price until the next cart change ("took a minute to sync"). On
    // restore, re-sync + re-verify so prices refresh immediately (gate locks checkout
    // while it does).
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        log('Restored from bfcache (e.g. back from checkout) — re-syncing cart');
        setCartVerifying(true);
        syncCartDiscounts(getTierFromCookie() || '');
      }
    });

    // Always sync cart discounts — promotions with b2b_only=0 are available to ALL
    // customers including retail and anonymous visitors. Non-B2B customers pass ''
    // so the Worker skips tier pricing but still evaluates public promotions.
    setupCartSyncInterceptor(tier || '');
    syncCartDiscounts(tier || '');

    // PDP quantity-break advert — `debug`-tagged accounts only (gated inside), and independent of
    // the tier flow so a debug account with no tier still gets it before the early return below.
    initQuantityBreaks(tier || '');

    // PDP quest badge — `debug`-tagged, logged-in accounts only (gated inside). Runs outside the
    // tier flow for the same reason: a `debug` account with no B2B tier still holds quests.
    initQuestBadge();

    var srcSegment = hasSourceSegment();
    if (!tier && !srcSegment) {
      log('No b2b_tier cookie and no source segment — retail/anonymous, promos-only sync triggered');
      // Retail IS the final price for this shopper, so release the quest badge before returning —
      // a `debug` account without a B2B tier still holds quests and must still see the badge.
      _tierApplied = true;
      renderQuestBadge();
      return; // Skip tier price display for non-B2B, non-segment customers
    }
    log('Cookie tier:', tier || '(none)', 'sourceSegment:', srcSegment);

    document.body.classList.add('b2b-loading');
    document.body.classList.add('b2b-active');
    log('Set b2b-active class on body');

    // A segment-only guest (no tier) bypasses the tier-keyed cache and always fetches fresh —
    // the segment price is cheap to fetch and this avoids any tier/segment cache-key collision.
    var cached = tier ? readCache(tier) : null;

    if (cached) {
      log('Using cached prices (age:', Math.round(cached._age / 1000) + 's)');
      applyAllPrices(cached);
      setupObservers(cached.skuPrices);
      setupRecommendationsObserver(cached.handlePrices);
      setupQuickViewObserver(cached.handlePrices);
      setupVariantChangeHandler(cached.skuPrices);
      document.body.classList.remove('b2b-loading');

      // Background refresh if past 50% TTL
      if (cached._age > REFRESH_AT) {
        log('Cache past 50% TTL, background refresh...');
        fetchPrices(tier).then(function (data) {
          writeCache(tier, data);
        }).catch(function () {});
      }
      return;
    }

    log('No cache — fetching from API...');
    // Cold cache — fetch from API
    fetchPrices(tier).then(function (data) {
      if (tier) writeCache(tier, data); // don't cache the segment-guest ('' tier) path
      applyAllPrices(data);
      setupObservers(data.skuPrices);
      setupRecommendationsObserver(data.handlePrices);
      setupQuickViewObserver(data.handlePrices);
      setupVariantChangeHandler(data.skuPrices);
      document.body.classList.remove('b2b-loading');
      log('Init complete');
    }).catch(function (err) {
      console.error('[B2B] Pricing fetch failed:', err);
      document.body.classList.remove('b2b-loading');
      // The tier price never arrived, so retail is what this shopper would actually pay — a
      // truthful basis for the badge. Better than hiding it forever on a transient failure.
      _tierApplied = true;
      renderQuestBadge();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
